// Main function to save quiz preferences
async function saveQuizPreferences(customerId) {
  // Get customer ID from parameter or form/wrapper
  if (!customerId) customerId = wrapper?.dataset?.customerId;

  // payload base
  const payload = {
    customer_id: customerId
  };

  if (!payload.customer_id) {
    return;
  }

  // Add personal details fields (only if they exist on the page)
  const firstNameInput = document.getElementById('AccountFirstName');
  const lastNameInput = document.getElementById('AccountLastName');
  const phoneInput = document.getElementById('AccountPhone');
  const birthdayInput = document.getElementById('AccountBirthday');
  
  // Only validate and add personal details if we're on the account page
  if (firstNameInput && lastNameInput) {
    // Clear any previous validation errors
    firstNameInput.setCustomValidity('');
    lastNameInput.setCustomValidity('');
    
    // Validate required fields
    if (!firstNameInput.value.trim()) {
      firstNameInput.setCustomValidity('Please enter your first name');
      firstNameInput.reportValidity();
      return false;
    }
    if (!lastNameInput.value.trim()) {
      lastNameInput.setCustomValidity('Please enter your last name');
      lastNameInput.reportValidity();
      return false;
    }
    
    // Add to payload
    payload.first_name = firstNameInput.value.trim();
    payload.last_name = lastNameInput.value.trim();
    if (phoneInput) payload.phone = phoneInput.value || '';
    if (birthdayInput) payload.birthday = birthdayInput.value || '';
  }

  // gets all the steps dynamically
  document.querySelectorAll('.quiz-select-container').forEach(container => {
    const field = container.dataset.field;          // ex.: favorite_brewing_method
    if (!field) return;

    const values = Array.from(container.querySelectorAll('input:checked'))
      .map(i => {
        // if it has data-gid, uses GID (account page), otherwise uses title (quiz page)
        if (i.dataset.gid) {
          const raw = i.dataset.gid.trim();
          return raw.startsWith('gid://') ? raw : (raw ? `gid://shopify/Metaobject/${raw}` : '');
        } else if (i.dataset.title) {
          return i.dataset.title.trim();
        }
        return '';
      })
      .filter(Boolean);

    payload[field] = values;
  });

  for (const [k, v] of Object.entries(payload)) {
    if (Array.isArray(v)) payload[k] = JSON.stringify(v);
  }

  try {
    const res = await fetch(window.makeComHookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  
    const ct = (res.headers.get('content-type') || '').toLowerCase();
    const bodyText = await res.text(); // READ ONLY ONCE
  
    // If success → do nothing
    if (res.ok) return true;
  
    // ---- ERROR ----
  
    let message = '';
    let field = '';
  
    // 1) Try to parse JSON
    try {
      const obj = JSON.parse(bodyText);
      if (obj && typeof obj === 'object') {
        message = (obj.message || obj.error || '').toString();
      }
    } catch (_) {
      message = bodyText || '';
    }
  
    // 2) Extract "field - message"
    const m = (message || '').match(/^\s*([a-zA-Z0-9_]+)\s*-\s*(.+?)\s*$/m);
    if (m && m[1] && m[2]) {
      field = m[1].trim().toLowerCase();
      message = m[2].trim();
    } else {
      message = (message || '').trim();
    }
  
    if (!message) return false;
  
    // 3) Find input dynamically
  
    let targetInput = null;
  
    // Explicit mapping (main fields)
    const fieldMap = {
      phone: 'AccountPhone',
      birthday: 'AccountBirthday'
    };
  
    if (field && fieldMap[field]) {
      targetInput = document.getElementById(fieldMap[field]);
    }
  
    // If not found by map, try by name
    if (!targetInput && field) {
      targetInput = document.querySelector(`[name="${field}"]`);
    }
  
    // If not found by name, try by id directly
    if (!targetInput && field) {
      targetInput = document.getElementById(field);
    }
  
    // Final fallback (if desired)
    if (!targetInput) {
      console.warn('⚠️ No input found for field:', field);
      alert(message);
      return false;
    }
  
    // Show error only in this field
    targetInput.setCustomValidity(message);
    targetInput.reportValidity();
    targetInput.focus();
  
    return false;
  
  } catch (e) {
    console.error(e);
    return false;
  }
}

// Auto-bind to save button when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  const saveBtn = document.getElementById('quiz-save-btn');
  if (!saveBtn) return;

  saveBtn.addEventListener('click', async function(event) {
    const btn = event.target;
    btn.classList.add('btn--loading');

    try {
      await saveQuizPreferences(btn.dataset.customerId);
    } finally {
      btn.classList.remove('btn--loading');
    }
  });
});
